import { getAccountId, getPartnerProxyId } from '@/utils/KeycloakUtils'
import { setSecret } from './CookieUtils'

const CP_USER_ID = 'cp_user_id'

// exchange crypto-js with native browser functions
export async function hashString(message: string) {
  // get a byte stream
  const encoder: TextEncoder = new TextEncoder()

  // create a Uint8Array object
  const data = encoder.encode(message)

  // create a hash as arrayBuffer
  const hashBuffer: ArrayBuffer = await crypto.subtle.digest(
    'SHA-256',
    data as BufferSource
  )

  // get the actual array
  const hashArray: number[] = Array.from(new Uint8Array(hashBuffer))

  // map the array to a hash string
  return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('')
}

export async function setCpUserIdCookie(): Promise<void> {
  const userId = await getCpUserId()
  setSecret(CP_USER_ID, userId)
}

async function getCpUserId(): Promise<string> {
  const partnerProxyId: string | null = getPartnerProxyId()
  if (!partnerProxyId) {
    throw new Error('No partner proxy id available!')
  }

  const accountId: string | null = getAccountId()
  if (!accountId) {
    throw new Error('No account id available!')
  }

  const fullString = partnerProxyId.toString() + accountId.toString()

  return hashString(fullString)
}
